import { useMemo, useState } from 'react';
import { useMount } from 'ahooks';
import { fetchGenreSourcesOptionsAll } from '@intelligence/components/GenreSelectMiddleware/services';
import { formatGenreSourcesOptions } from '@intelligence/v3/utils/genre';

import type { IGenreRes } from '@intelligence/types/common';
import type { IGenreSourcesGenreOptions } from '@intelligence/components/GenreSelect/types';

export default function usePCConsoleGenreOptionsMap(entityType: string) {
  const [loading, setLoading] = useState(true);
  const [map, setMap] = useState<IGenreRes>({} as unknown as IGenreRes);

  const formatedMap = useMemo<IGenreSourcesGenreOptions>(() => {
    if (loading) {
      return {};
    }

    return formatGenreSourcesOptions(map);
  }, [loading, map]);

  const updateMap = async () => {
    try {
      setLoading(true);
      const res = await fetchGenreSourcesOptionsAll(entityType);
      setMap(res?.data || {});
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useMount(() => {
    void updateMap();
  });

  return { loading, map, formatedMap };
}
